import * as React from 'react';
import { connect } from 'react-redux';
import LinkButton from '../../components/Button/LinkButton';
const styles = require('./Home.less') as any;
//import classNames from 'classnames';
/* import { debug } from '../../../utils';
 * const log = debug('lego:Home.tsx');*/

import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
const mapStateToProps = (state) => ({
    isAuthenticated: !isEmpty(get(state, 'account.data'))
});
@connect(mapStateToProps)
export default class Home extends React.Component<any,any> {
		render() {
        const { isAuthenticated } = this.props;
				return (
					<div id={styles.Home}>
						<h1>Welcome to AccessPlace</h1>
						<div>
							<div>
								Welcome to the Access Ratings for Buildings (AR-B) app! You can use this app to...
								<ol>
									<li><strong>Find Accessibility</strong> information about a building</li>
									<li><strong>Submit your own ratings</strong> of a building's accessibility.</li>
								</ol>
							</div>
						</div>
						<div>
							<p className={styles.Callout}>
								AccessPlace is brand new. Depending on your location there may be few reviews available. The quality of the site depends on ratings from the community. We would like you to leave great reviews and comments for others to see. Encourage your friends to use the site too!
							</p>
							{!isAuthenticated && <p>
								If this is your first time visiting Access Place, click "Register" to create a username and password that
								you will use to log in each time you come back. Then, create a profile so that you we can show you
								reviews by users most similar to you.
							</p>}

										{isAuthenticated && <p>
								To leave or find reviews, click the Get Started button or click Search in the upper right corner.
								To change your settings, create or edit your profile, view your reviews, or change your e-mail address or
								password, go to Account.
										</p>}
						</div>
						<div>
							{isAuthenticated ?
							 <div>
								 <LinkButton to='/Search/'>Get Started</LinkButton>
							 </div> :
							 <div>
								 <LinkButton to='/Register'>Register</LinkButton>
								 <LinkButton to='/Login'>Log in</LinkButton>
							 </div>}
						</div>
					</div>
				);
		}
}



// WEBPACK FOOTER //
// ./src/app/containers/Home/Home.tsx